<script>
import TextType from "./TextType.vue";
import { QuestionType } from "../../models/QuestionModel";

export default {
  extends: TextType,
  name: QuestionType.Phone,
  data() {
    return {
      inputType: "tel",
      canReceiveFocus: true,
      allowedChars: "0123456789.+"
    };
  },
  methods: {
    validate() {
      if (this.required) {
        return this.hasValue;
      } else {
        return true;
      }
    }
  }
};
</script>
